<template>
  <div style="display: none;"></div>
</template>

<script>
  const ffmpeg = require('@salomvary/ffmpeg.js-umd/ffmpeg-mp4.js')

  export default {
    props: {
      videoFile: File,
      audioFile: File,
      onFinish: Function
    },
    created () {
      // Auto-start processing when the component loads.
      this.mux(this.videoFile, this.audioFile, this.onFinish).then(this.onFinish)
    },
    methods: {
      mux: async function(videoFile, audioFile) {
          let arrayBufferVideo = await videoFile.arrayBuffer();
          let arrayBufferAudio = await audioFile.arrayBuffer();
          let output = ffmpeg({
            MEMFS: [{name: "video.mp4", data: arrayBufferVideo}, {name: "audio.mp4", data: arrayBufferAudio}],
            arguments: ["-i", "video.mp4", "-i", "audio.mp4", "-shortest", "-c", "copy", "out.mp4"],

            stdin: function() {},
            stdout: function() {},
            print: function(_) {_},
            printErr: function(_) {_},
            onExit: function(_) {_}
          })
          output = new Blob([output.MEMFS[0].data], { type: "video/mp4" });
          return URL.createObjectURL(output)
      },
    },
  };
</script>
